namespace GeniuzPOS.AdvPromo {
    export enum amtorpcFg {
        amtorpcFgFg0 = 0,
        amtorpcFgFg1 = 1,
        amtorpcFgFg2 = 2
    }
    Serenity.Decorators.registerEnumType(amtorpcFg, 'GeniuzPOS.AdvPromo.amtorpcFg');
}
